module.exports = __webpack_public_path__ + "img/118.4d3f494f.jpg";